export default "__VITE_ASSET__B6V6tAbp__"